import {
    WGCWX_SHOP_REWARDS_TANK_ACTION_ERROR,
    WGCWX_SHOP_REWARDS_TANK_ACTION_REQUEST,
    WGCWX_SHOP_REWARDS_TANK_ACTION_SUCCESS,
    WGCWX_SHOP_REWARDS_TANKS_ERROR,
    WGCWX_SHOP_REWARDS_TANKS_REQUEST,
    WGCWX_SHOP_REWARDS_TANKS_SUCCESS,
} from 'state/actions/wgcwx_shop'
import { C2W_EVENT_TYPES, VEHICLE_STATE } from '@wotfe/client2web'
import sortBy from 'lodash/sortBy'

const defaultState = {
    loading: false,
    processing: false,
    errorMessage: null,
    errorActionType: null,
    goods: null,
    accountInfo: null,
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
    case C2W_EVENT_TYPES.UPDATE_VEHICLE_STATE: {
        const { id: vehicleId, state: reason } = action.data
        const vehicle = state.goods.find(({ token }) => token === vehicleId)
        // if changed vehicle not related to our logic just return state
        if (!vehicle) {
            return state
        }

        let goods = state.goods.filter((v) => v !== vehicle)
        // reason === VEHICLE_STATE.NOT_PRESENT means that vehicle was deleted from inventory
        goods.push({
            ...vehicle,
            inHangar: reason !== VEHICLE_STATE.NOT_PRESENT,
        })

        goods = sortBy(goods, ['id'])

        return {
            ...state,
            goods,
        }
    }
    case WGCWX_SHOP_REWARDS_TANKS_REQUEST:
        return {
            ...state,
            loading: true,
            errorMessage: null,
            errorActionType: null,
        }
    case WGCWX_SHOP_REWARDS_TANKS_SUCCESS: {
        return {
            ...state,
            loading: false,
            ...action.payload,
        }
    }
    case WGCWX_SHOP_REWARDS_TANKS_ERROR:
        return {
            ...state,
            loading: false,
            errorMessage: action.payload.errorMessage,
            errorActionType: action.payload.errorActionType,
        }
    case WGCWX_SHOP_REWARDS_TANK_ACTION_REQUEST: {
        return {
            ...state,
            processing: true,
            errorMessage: null,
            errorActionType: null,
        }
    }
    case WGCWX_SHOP_REWARDS_TANK_ACTION_SUCCESS: {
        return {
            ...state,
            processing: false,
        }
    }
    case WGCWX_SHOP_REWARDS_TANK_ACTION_ERROR: {
        return {
            ...state,
            processing: false,
            errorMessage: action.payload.errorMessage,
            errorActionType: action.payload.errorActionType,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/wgcwx_shop/rewards.js